export default __webpack_public_path__ + "static/media/call.94e3f3e8.svg";